import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useState } from "react";

import type { NavigationType } from "../Header";

export type Props = {
  navigationName: string;
  dropdownMenu: Array<{
    id: ID;
    title?: string;
    dropdownMenuPages: Array<{
      id: ID;
      title: string;
      url: string;
      imageUrl?: string;
      imageAlternativeText: string | null;
    }>;
  }> | null;
  navigationUrl: string;
  type: NavigationType;
  onRouteClick: () => void;
  clickHeaderSub: (targetUrl: string) => void;
  clickHeaderMain: (targetUrl: string) => void;
  dataTestId?: string;
};

export const NavbarItemMobile: FC<Props> = ({
  navigationName,
  dropdownMenu,
  navigationUrl,
  type,
  onRouteClick,
  clickHeaderSub,
  clickHeaderMain,
  dataTestId,
}) => {
  const [activeBlocks, setActiveBlocks] = useState<Array<number>>([]);

  const { Link } = useUiKitComponents();
  const toggleAccordion = (id: number): void => {
    if (activeBlocks.includes(id)) {
      setActiveBlocks((prevState) =>
        prevState.filter((activeBlockId) => activeBlockId !== id),
      );
    } else {
      setActiveBlocks((prevState) => [...prevState, id]);
    }
  };

  return (
    <div className="navbar-accordion-mobile" ata-testid={dataTestId}>
      {(!type || type === "default" || type === "dropdown") &&
        dropdownMenu?.map((dropdown, idx) => (
          <div
            className={`navbar-menu-accordion-item ${
              activeBlocks.includes(+dropdown.id) && "open"
            }`}
            key={dropdown.id}
            data-testid={`navbar-item-${idx}`}
          >
            {(dropdown?.title ?? navigationName) && (
              <div onClick={() => toggleAccordion(+dropdown.id)}>
                <div className="navbar-menu-accordion-question">
                  <Link
                    onClick={() => {
                      onRouteClick();
                      clickHeaderMain(navigationUrl);
                    }}
                    href={navigationUrl}
                  >
                    <h5 className="navbar-menu-accordion-title">
                      {dropdown.title ?? navigationName}
                    </h5>
                  </Link>
                  <svg
                    className={`navbar-menu-accordion-icon ${
                      activeBlocks.includes(+dropdown.id) ? "rotated" : ""
                    }`}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.7">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </div>
              </div>
            )}
            <div className="navbar-accordion-content-wrapper">
              {dropdown.dropdownMenuPages?.map((subpage) => (
                <Link
                  href={subpage.url}
                  className="navbar-menu-subpage"
                  key={subpage.id}
                  onClick={() => {
                    onRouteClick();
                    clickHeaderSub(subpage.url);
                  }}
                >
                  <img
                    src={subpage?.imageUrl}
                    alt={subpage.imageAlternativeText ?? ""}
                  />
                  <span className="navbar-menu-subpage-title base-body2-text">
                    {subpage.title}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        ))}

      {type === "jackpass" && (
        <div className="navbar-item-jackpass-wrapper">
          <div className="navbar-item-jackpass">
            <Link
              href={navigationUrl || "/"}
              onClick={() => {
                onRouteClick();
                clickHeaderMain(navigationUrl);
              }}
              className="navbar-item-content-jackpass"
            >
              {navigationName}
            </Link>
          </div>
        </div>
      )}

      {(type === "vip" || type === "jackvip") && (
        <div
          className="navbar-item-vip navbar-item-mobile-wrapper"
          style={{ marginTop: type === "vip" ? "24px" : 0 }}
        >
          <div className="navbar-item-vip-icon" />
          <Link
            href={navigationUrl || "/"}
            className="navbar-item-content-vip"
            onClick={() => {
              onRouteClick();
              clickHeaderMain(navigationUrl);
            }}
          >
            {navigationName}
          </Link>
          <div className="navbar-item-vip-icon" />
        </div>
      )}

      {type === "default" && (
        <Link
          href={navigationUrl}
          className="navbar-item-content-default"
          onClick={() => {
            onRouteClick();
            clickHeaderMain(navigationUrl);
          }}
        >
          <div className="navbar-item-default navbar-item-mobile-wrapper">
            {navigationName}
          </div>
        </Link>
      )}

      {type === "leaderboard" && (
        <div className="navbar-item-default navbar-item-mobile-wrapper">
          <Link
            className="navbar-item-leaderboard"
            href={navigationUrl}
            onClick={() => {
              onRouteClick();
              clickHeaderMain(navigationUrl);
            }}
          >
            {navigationName}
          </Link>
        </div>
      )}
    </div>
  );
};
